import React from "react";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import PersonalSetting from "./PersonalSetting";
import PortalUsers from "./PortalUsers";
import ClientUser from "./ClientUser";
import MasterTab from "./Master/MasterTab";
import RateperHour from "./RateperHour";
import Monthlylogs from "./monthlyLogs/Monthlylogs";
import Pagenotfound from "../../components/common/Pagenotfound";
import Twofactor from "./Twofactor/Twofactor";

function Settings() {
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { role: login_user_role } = login_user || {};
  const location = useLocation();

  const isActiveTab = (path) => location.pathname.includes(path);

  return (
    <div className="bg-white p-3 detailpage">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-4" role="presentation">
          <Link
            to="PersonalSettings"
            className={`nav-link ${isActiveTab("PersonalSettings") ? "active" : ""
              }`}
          >
            Personal Settings
          </Link>
        </li>

        {(login_user_role === "ADMIN" || login_user_role === "MANAGER") && (
          <>
            <li className="nav-item pe-4" role="presentation">
              <Link
                to="Portal-Users"
                className={`nav-link ${isActiveTab("Portal-Users") ? "active" : ""
                  }`}
              >
                Portal Users
              </Link>
            </li>
            <li className="nav-item pe-4" role="presentation">
              <Link
                to="Client-Users"
                className={`nav-link ${isActiveTab("Client-Users") ? "active" : ""
                  }`}
              >
                Client Users
              </Link>
            </li>
            <li className="nav-item pe-4" role="presentation">
              <Link
                to="rateperhour"
                className={`nav-link ${isActiveTab("rateperhour") ? "active" : ""
                  }`}
              >
                Rate Per Hour
              </Link>
            </li>
          </>
        )}

        {login_user_role === "ADMIN" && (
          <>
            <li className="nav-item pe-4" role="presentation">
              <Link
                to="Master"
                className={`nav-link ${isActiveTab("Master") ? "active" : ""}`}
              >
                Master
              </Link>
            </li>
            <li className="nav-item pe-4" role="presentation">
              <Link
                to="monthlylogs"
                className={`nav-link ${isActiveTab("monthlylogs") ? "active" : ""
                  }`}
              >
                Monthly Logs
              </Link>
            </li>
            <li className="nav-item pe-4" role="presentation">
              <Link
                to="twofactor"
                className={`nav-link ${isActiveTab("twofactor") ? "active" : ""
                  }`}
              >
                Two Factor
              </Link>
            </li>
          </>
        )}
      </ul>

      {/* Routes */}
      <div className="tab-content" id="myTabContent">
        <Routes>
          <Route index element={<Navigate to="PersonalSettings" replace />} />
          <Route path="PersonalSettings" element={<PersonalSetting />} />

          {(login_user_role === "ADMIN" || login_user_role === "MANAGER") && (
            <>
              <Route path="Portal-Users" element={<PortalUsers />} />
              <Route path="Client-Users" element={<ClientUser />} />
              <Route path="rateperhour" element={<RateperHour />} />
            </>
          )}

          {login_user_role === "ADMIN" && (
            <>
              <Route path="Master/*" element={<MasterTab />} />
              <Route path="monthlylogs/*" element={<Monthlylogs />} />
              <Route path="twofactor/*" element={<Twofactor />} />

            </>
          )}

          {/* Catch-all for undefined routes */}
          <Route path="*" element={<Pagenotfound />} />
        </Routes>
      </div>
    </div>
  );
}

export default Settings;
